import React, { useState, useEffect } from "react";

const Header = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 w-full z-20 transition-colors duration-300 ${isScrolled ? "bg-gradient-conic z-[100]" : "bg-custom-gradient"
        }`}
    >
      <div className="max-w-[1800px] mx-auto flex justify-between items-center py-4 pr-4 pl-12 md:pl-20 md:pr-10">
        <a href="/" className="flex items-center h-12 w-56">
          <img alt="logo"
            src="/images/INTERPETRO_LOGO.png"
            className="size-full object-contain"
          />
        </a>
        <nav className="hidden md:flex space-x-6">
          <a href="/" className="text-white hover:text-gray-300">
            Home
          </a>
          <a href="/about-us" className="text-white hover:text-gray-300">
            About Us
          </a>
          <a href="/contact-us" className="text-white hover:text-gray-300">
            Contact Us
          </a>
        </nav>
        <button
          className="md:hidden focus:outline-none"
          onClick={toggleDrawer}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 5.25h16.5m-16.5 6h16.5m-16.5 6h16.5"
            />
          </svg>
        </button>
      </div>
      {isDrawerOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={toggleDrawer}
        ></div>
      )}
      <div
        className={`fixed inset-0 bg-gray-800 text-white md:hidden transition-all duration-300 ease-in-out transform ${isDrawerOpen
          ? "translate-x-full opacity-100 z-50 w-2/4 text-left"
          : "translate-x-full opacity-0"
          }`}
      >
        <nav className="space-y-4 px-6 py-4">
          <button onClick={toggleDrawer} className="no-underline text-white text-[20px] absolute top-[2%] leading-none -left-6 bg-gray-800 p-2 rounded-l-md">X</button>
          <a href="/" className="block hover:text-gray-300 !mt-12" onClick={toggleDrawer}>
            Home
          </a>
          <a href="/about-us" className="block hover:text-gray-300" onClick={toggleDrawer}>
            About Us
          </a>
          <a href="/contact-us" className="block hover:text-gray-300" onClick={toggleDrawer}>
            Contact Us
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Header;
